import axios from "./axios";
import store from "../store";

export default {
  //New functions should ALWAYS come on top here for easy updates
  getColors() {
    return [
      "#0277BD",
      "#263238",
      "#424242",
      "#1B5E20",
      "#311B92",
      "#FF9800",
      "#37474F",
      "#880E4F",
      "#1A237E",
      "#009688",
      "#2196F3",
      "#9C27B0",
      "#827717",
      "#880E4F",
      "#00796B",
      "#3E2723",
      "#3949AB",
      "#F44336",
      "#FFAB00",
      "#E65100",
      "#827717",
      "#BF360C",
      "#D81B60",
      "#3E2723",
      "#FFAB00",
      "#000000",
      "#2196F3",
      "purple",
      "#B71C1C",
    ];
  },
  getObjectFromArrayOfObjects(arrayOfObjects, objectLookingFor, property) {
    const result = arrayOfObjects.find((obj) => {
      return obj[property] === objectLookingFor[property];
    });
    return result;
  },
  async getLogos(emis) {
    const logos = await axios.postDataWithToken(
      "/auth/get-logos-for-given-school",
      {
        folder: "logos",
        emis: emis,
      },
      localStorage.getItem("token")
    );
    return logos;
  },

  //last compare and update below.

  async login(email, password) {
    const response = await axios.postData("/auth/login", {
      email,
      password,
    });

    if (response && response.status != 401) {
      store.commit("setAccessToken", response.token);
      store.commit("setCurrentUser", response.user);
      store.commit("setAuthenticated", true);

      localStorage.setItem("token", response.token);
      localStorage.setItem("authenticated", true);
      localStorage.setItem("user", JSON.stringify(response.user));
      return true;
    } else {
      return false;
    }
  },
  async signOut() {
    const response = await axios.postDataWithToken(
      "/auth/logout",
      {},
      localStorage.getItem("token")
    );

    if (response && response.loggedOut) {
      store.commit("setAuthenticated", false);
      store.commit("setCurrentUser", {});
      store.commit("setCurrentStudent", {});
      localStorage.clear();
      location.reload();
    } else {
      alert("Oops, something went wrong!");
      return false;
    }
  },
  async updateModelSingleRow(table, column, id, value) {
    const response = await axios.postDataWithToken(
      "/auth/update-model-single-row",
      {
        table,
        column,
        id,
        value,
      },
      localStorage.getItem("token")
    );
    return response;
  },

  getIDsFromObjs(objArray) {
    const idCollection = [];
    objArray.forEach((id) => {
      if (typeof id == "object") {
        idCollection.push(id.id);
      } else {
        idCollection.push(id);
      }
    });
    return idCollection;
  },

  async updateModelMultipleRows(table, column, ids, value) {
    const response = await axios.postDataWithToken(
      "/auth/update-model-multiple-rows",
      {
        table,
        column,
        ids,
        value,
      },
      localStorage.getItem("token")
    );
    return response;
  },

  removeObjectFromArrayByObjectOrObjectID(objArray, selectedObjsArrayOrID) {
    if (
      Array.isArray(selectedObjsArrayOrID) &&
      selectedObjsArrayOrID.length > 0
    ) {
      selectedObjsArrayOrID.forEach((item) => {
        objArray.forEach((rowObj, index) => {
          if (rowObj.id == item.id) {
            objArray.splice(index, 1);
          }
        });
      });
    } else {
      objArray.forEach((rowObj, index) => {
        if (rowObj.id == selectedObjsArrayOrID) {
          objArray.splice(index, 1);
        }
      });
    }
    return objArray;
  },

  async deleteMultipleRows(table, ids) {
    ids = this.getIDsFromObjs(ids);
    const response = await axios.postDataWithToken(
      "/auth/delete-multiple-rows",
      {
        table,
        ids,
      },
      localStorage.getItem("token")
    );
    return response;
  },

  async deleteSingleRow(table, id) {
    const response = await axios.postDataWithToken(
      "/auth/delete-single-row",
      {
        table,
        id,
      },
      localStorage.getItem("token")
    );
    return response;
  },

  async sendGeneralEmail(emailAddress, subject, body, link, linkDescription) {
    const response = await axios.postDataWithToken(
      "/auth/send-general-email",
      {
        emailAddress,
        subject,
        body,
        link,
        linkDescription,
      },
      localStorage.getItem("token")
    );
    return response;
  },

  formatUnderscoreNamesWithFirstCapitalLetters(name) {
    let formattedName = "";
    if (name && name.includes("_")) {
      formattedName = name.replace("_", " ");
    } else {
      formattedName = name;
    }

    const names = formattedName.split(" ");
    if (names.length > 1) {
      let parts = "";
      names.forEach((tab) => {
        parts += this.capitalizeFirstCharacter(tab) + " ";
      });
      formattedName = parts;
    } else {
      formattedName = this.capitalizeFirstCharacter(names[0]);
    }
    return formattedName;
  },

  async sendGeneralEmailNoToken(
    emailAddress,
    subject,
    body,
    link,
    linkDescription
  ) {
    const response = await axios.postData("/send-general-email-no-token", {
      emailAddress,
      subject,
      body,
      link,
      linkDescription,
    });
    return response;
  },
  getObjectKeys(object) {
    return Object.keys(object);
  },

  uploadFile(file, folder) {
    const fileArr = file.name.split(".");
    const ext = fileArr[fileArr.length - 1];
    const extensions = [
      "xls",
      "xlsx",
      "doc",
      "docx",
      "ppt",
      "pptx",
      "png",
      "jpg",
      "jpeg",
      "txt",
    ];

    if (extensions.includes(ext)) {
      const filename = file.name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        const file64 = fileReader.result;
        store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/upload-file",
            {
              base64string: file64,
              filename: filename,
              folder: folder,
            },
            localStorage.getItem("token")
          )
          .then(() => {
            store.commit("setLoader", false);
          });
      });
      fileReader.readAsDataURL(file);
      return true;
    } else {
      return false;
    }
  },

  stripCommasFromMoney(amount) {
    let newAmount = amount;
    if (amount.includes(",")) {
      newAmount = amount.replace(",", "");
    }

    if (amount.includes("R")) {
      newAmount = amount.replace("R", "");
    }

    if (amount.includes("ZAR")) {
      newAmount = amount.replace("ZAR", "");
    }
    return newAmount.trim();
  },

  capitalizeFirstCharacter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },

  getIframeSource(filename) {
    return store.state.apiUrl + "/auth/excel_templates/" + filename;
  },
  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      const i = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString();
      const j = i.length > 3 ? i.length % 3 : 0;

      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : "")
      );
    } catch (e) {
      //console.log(e)
    }
  },

  async getLogos(emis) {
    const logos = await axios.postData("/get-logos-for-given-company", {
      folder: "logos",
      emis: emis,
    });

    return logos;
  },
};
